import { render, staticRenderFns } from "./NdfPositions.vue?vue&type=template&id=956c0a70&scoped=true"
import script from "./NdfPositions.vue?vue&type=script&lang=js"
export * from "./NdfPositions.vue?vue&type=script&lang=js"
import style0 from "./NdfPositions.vue?vue&type=style&index=0&id=956c0a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c0a70",
  null
  
)

export default component.exports